import { memo } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";

const ModernCard = memo(
  ({ title, icon: Icon, children, color = "primary", ...props }) => {
    const theme = useTheme();

    return (
      <Card
        sx={{
          mb: 3,
          boxShadow: theme.shadows[4],
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            boxShadow: theme.shadows[8],
            transform: "translateY(-2px)",
          },
          border: `1px solid ${theme.palette.divider}`,
          ...props.sx,
        }}
      >
        <CardHeader
          avatar={
            Icon && (
              <Avatar
                sx={{
                  bgcolor: `${color}.main`,
                  color: `${color}.contrastText`,
                }}
              >
                <Icon />
              </Avatar>
            )
          }
          title={
            <Typography variant="h6" fontWeight="bold" color="text.primary">
              {title}
            </Typography>
          }
          sx={{
            bgcolor: "background.paper",
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        />
        <CardContent sx={{ p: 3 }}>{children}</CardContent>
      </Card>
    );
  }
);

ModernCard.displayName = "ModernCard";

ModernCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  sx: PropTypes.object,
};

export default ModernCard;
